import React, { useState, useEffect } from "react";
import { useNavigate, Route, Link, Routes, Navigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { UserProvider } from "./UserContext";
import { useUser } from "./UserContext";
import { fetchUserDetails } from "./api/api";
import { SupplierProvider } from "./SupplierContext";
import { ProductProvider } from "./ProductContext";
import { CustomerProvider } from "./CustomerContext";
import { OrderProvider } from "./OrderContext";
import { CartProvider } from "./CartContext";
import { CategoryProvider } from "./CategoryContext";
import { AccountProvider } from "./contextjs/AccountContext";
import { TransactionProvider } from "./contextjs/TransactionContext";
import { LedgerReportsProvider } from "./contextjs/LedgerReportsContext";
import { AccountingReportsProvider } from "./contextjs/AccountingReportsContext";
import { NotesProvider } from "./contextjs/NotesContext";
import { CompanyProvider } from "./contextjs/CompanyContext";
import { PurchaseProvider } from "./PurchaseContext";
import { StockLedgerProvider } from "./contextjs/StockLedgerContext";
import { FinancialYearProvider } from "./contextjs/FinancialYearContext";
import { StockTransferProvider } from "./contextjs/StockTransferContext";

import Login from "./components/login";
import SignUp from "./components/SignUp";
import PrivateRoute from "./components/privateroute";
import UserMenu from "./components/usermenu";
import NotAuthorized from "./components/notauthorized";
import Profile from "./components/profile";
import AuditLogPage from "./components/auditlogpage";
import Inventory from "./components/inventory";
import AccountingHomepage from "./components/Accounting/accountinghomepage";
import Accounts from "./components/Accounting/accounts";
import Transactions from "./components/Accounting/transactions";
import ExpenseEntry from "./components/Accounting/expense";
import AccountingReports from "./components/Accounting/accountingreports";
import LedgerReports from "./components/Accounting/reportsmodules/ledgerreports";
import BalanceSheetReport from "./components/Accounting/reportsmodules/balancesheet";
import IncomeStatementReport from "./components/Accounting/reportsmodules/incomestatement";
import IncomeStatementHistoricalReport from "./components/Accounting/reportsmodules/incomestatementhistoricalreport";
import IncomeStatementFYSelector from "./components/Accounting/reportsmodules/incomestatementfyselector";
import TrialBalanceReport from "./components/Accounting/reportsmodules/trialbalance";
import Taxes from "./components/Accounting/taxes";
import Payroll from "./components/Accounting/payroll";
import AccountsAuditLog from "./components/Accounting/accountsauditlog";
import CurrentAssets from "./components/Accounting/currentassets";
import Budgets from "./components/Accounting/budgets";
import Branches from "./components/branches";
import Warehouse from "./components/warehouse";
import POS from "./components/pos";
import Checkout from "./components/POS/checkout";
import Receipt from "./components/POS/receipt";
import Customer from "./components/CRM/customer";
import Orders from "./components/orders";
import Reports from "./components/reports";
import ReturnedOrders from "./components/returnedorders";
import ProductsReport from "./components/productsreport";
import Product from "./components/inventory/product";
import Purchase from "./components/inventory/purchase";
import Supplier from "./components/inventory/supplier";
import Notes from "./components/notes";
import CompanyInfo from "./components/companyinfo";
import StockLedger from "./components/inventory/stockledger";
import FinancialYears from "./components/Accounting/financialyears";
import StoreSelector from "./components/StoreSelector";
import StoreInventory from "./components/inventory/storeinventory";
import StoreReorderLevels from "./components/inventory/storereorderlevels";
import StockTransferPage from "./components/inventory/stocktransfer";

// homepage imports
import {Container, Row, Col, Card, Table} from "react-bootstrap";
import { useProducts } from "./ProductContext";
import { useOrders } from "./OrderContext";
import { useAccounts } from "./contextjs/AccountContext";
import { useTransactions } from "./contextjs/TransactionContext";
import { useCustomers } from "./CustomerContext";
import { useSuppliers } from "./SupplierContext";
import { usePurchases } from "./PurchaseContext";
import { useNotes } from "./contextjs/NotesContext";

function App() {
    // const [isAuthenticated, setIsAuthenticated] = useState(false);
    const { setUser } = useUser();
    // const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
    const [showSidebar, setShowSidebar] = useState(true);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            fetchUserDetails().then((userDetails) => {
                setUser(userDetails);
                // console.log('User Details:', userDetails);
            }).catch((error) => {
                console.error('Error fetching user details:', error);
                localStorage.removeItem('token');
                // setIsAuthenticated(false);
                setUser(null);
            });
        } else {
            // setIsAuthenticated(false);
            setUser(null);
        }
    }, [setUser]);

    const handleLogin = (token) => {
        localStorage.setItem('token', token);
        // setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        // setIsAuthenticated(false);
        setUser(null);
        navigate('/login');
    };

    const ProtectedRoute = ({ children }) => {
        const { user } = useUser();

        if (!user) {
            return <Navigate to="/login" />;
        }
        return children;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dropdown')) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        // <UserProvider>
            <CategoryProvider>
                <SupplierProvider>
                    <ProductProvider>
                        <CustomerProvider>
                            <PurchaseProvider>
                                <OrderProvider>
                                    <CartProvider>
                                        <AccountProvider>
                                            <TransactionProvider>
                                                <LedgerReportsProvider>
                                                    <AccountingReportsProvider>
                                                        <NotesProvider>
                                                            <CompanyProvider>
                                                                <StockLedgerProvider>
                                                                    <FinancialYearProvider>
                                                                        <StockTransferProvider>
                                                                            <div className="App">
                                                                                <div className={`hamburger-icon ${showSidebar ? '' : 'active'}`} onClick={() => setShowSidebar(!showSidebar)}>
                                                                                    <span></span>
                                                                                    <span></span>
                                                                                    <span></span>
                                                                                </div>
                                                                                <Routes>
                                                                                    <Route path="/login" element={<Login onLogin={handleLogin} />} />
                                                                                    <Route path="/signup" element={<SignUp />} />
                                                                                    <Route path="/not-authorized" element={<NotAuthorized />} />
                                                                                    <Route
                                                                                        path="/*"
                                                                                        element={
                                                                                            <ProtectedRoute>
                                                                                                {showSidebar && <Sidebar isDropdownOpen={isDropdownOpen} setIsDropdownOpen={setIsDropdownOpen} handleLogout={handleLogout} />}
                                                                                                <div className={`main-content ${!showSidebar ? 'full-width' : ''}`}>
                                                                                                    {/*location of top right user menu*/}
                                                                                                    <div className="user-menu-container">
                                                                                                        <StoreSelector/>
                                                                                                        <UserMenu handleLogout={handleLogout} />
                                                                                                    </div>
                                                                                                    <Routes>
                                                                                                        <Route path="/" element={<Home />} />
                                                                                                        <Route path="/profile" element={
                                                                                                            <ProtectedRoute>
                                                                                                                <Profile />
                                                                                                            </ProtectedRoute>
                                                                                                        } />
                                                                                                        <Route path="/audit-logs" element={
                                                                                                            <PrivateRoute requiredRoles={['Administrator', 'Superuser']}>
                                                                                                                <AuditLogPage />
                                                                                                            </PrivateRoute>
                                                                                                        } />
                                                                                                        {/*accounting routes*/}
                                                                                                        <Route path="/accounting" element={
                                                                                                            <PrivateRoute requiredRoles={['Accountant', 'Administrator']}>
                                                                                                                <AccountingHomepage />
                                                                                                            </PrivateRoute>
                                                                                                        } />
                                                                                                        <Route path="/accounting/accounts" element={
                                                                                                            <PrivateRoute requiredRoles={['Accountant', 'Administrator']}>
                                                                                                                <Accounts />
                                                                                                            </PrivateRoute>
                                                                                                        } />
                                                                                                        <Route path="/accounting/expense" element={
                                                                                                            <PrivateRoute requiredRoles={['Accountant', 'Administrator']}>
                                                                                                                <ExpenseEntry />
                                                                                                            </PrivateRoute>
                                                                                                        } />
                                                                                                        <Route path="/accounting/currentassets" element={
                                                                                                            <PrivateRoute requiredRoles={['Accountant', 'Administrator']}>
                                                                                                                <CurrentAssets />
                                                                                                            </PrivateRoute>
                                                                                                        } />
                                                                                                        <Route path="/accounting/transactions" element={<Transactions />} />
                                                                                                        <Route path="/accounting/reports" element={<AccountingReports />} />
                                                                                                        <Route path="/accounting/reportsmodules/ledgerreports" element={<LedgerReports />} />
                                                                                                        <Route path="/accounting/reports/balance-sheet" element={<BalanceSheetReport />} />
                                                                                                        <Route path="/accounting/reports/income-statement" element={<IncomeStatementReport />} />
                                                                                                        <Route path="/accounting/reports/income-statement-historical/:fyId" element={<IncomeStatementHistoricalReport />} />
                                                                                                        <Route path="/accounting/reports/income-statement-fy-selector" element={<IncomeStatementFYSelector />} />
                                                                                                        <Route path="/accounting/reports/trial-balance" element={<TrialBalanceReport />} />
                                                                                                        <Route path="/accounting/budgets" element={<Budgets />} />
                                                                                                        <Route path="/accounting/taxes" element={<Taxes />} />
                                                                                                        <Route path="/accounting/payroll" element={<Payroll />} />
                                                                                                        <Route path="/accounting/accountsauditlog" element={<AccountsAuditLog />} />
                                                                                                        <Route path="/accounting/financial-years" element={<FinancialYears />} />
                                                                                                        {/*end of accounting routes*/}
                                                                                                        <Route path="/branches" element={<Branches />} />
                                                                                                        <Route path="/inventory" element={
                                                                                                            <PrivateRoute requiredRoles={['Inventory Manager', 'Administrator']}>
                                                                                                                <Inventory />
                                                                                                            </PrivateRoute>
                                                                                                        } />
                                                                                                        <Route path="/POS/checkout" element={<Checkout />} />
                                                                                                        <Route path="/POS/receipt" element={<Receipt />} />
                                                                                                        <Route path="/CRM/customers" element={<Customer />} />
                                                                                                        <Route path="/inventory/products" element={<Product />} />
                                                                                                        <Route path="/inventory/purchases" element={<Purchase />} />
                                                                                                        <Route path="/inventory/suppliers" element={<Supplier />} />
                                                                                                        <Route path="/inventory/reorder-levels" element={<StoreReorderLevels />} />
                                                                                                        <Route path="/orders" element={<Orders />} />
                                                                                                        <Route path="/orders/returns" element={<ReturnedOrders />} />
                                                                                                        <Route path="/pos" element={<POS />} />
                                                                                                        <Route path="/reports" element={<Reports />} />
                                                                                                        <Route path="/reports/products" element={<ProductsReport />} />
                                                                                                        <Route path="/warehouse" element={<Warehouse />} />
                                                                                                        <Route path="/notes" element={<Notes />} />
                                                                                                        <Route path="/company-info" element={
                                                                                                            <PrivateRoute requiredRoles={['Administrator']}>
                                                                                                                <CompanyInfo />
                                                                                                            </PrivateRoute>
                                                                                                        } />
                                                                                                        <Route path="/inventory/stock-ledger" element={<StockLedger />} />
                                                                                                        <Route path="/inventory/stock-transfer" element={<StockTransferPage />} />
                                                                                                        <Route path="/inventory/store-inventory" element={<StoreInventory />} />
                                                                                                    </Routes>
                                                                                                </div>
                                                                                            </ProtectedRoute>
                                                                                        }
                                                                                    />
                                                                                </Routes>
                                                                                {/*<ToastContainer />*/}
                                                                            </div>
                                                                        </StockTransferProvider>
                                                                    </FinancialYearProvider>
                                                                </StockLedgerProvider>
                                                            </CompanyProvider>
                                                        </NotesProvider>
                                                    </AccountingReportsProvider>
                                                </LedgerReportsProvider>
                                            </TransactionProvider>
                                        </AccountProvider>
                                    </CartProvider>
                                </OrderProvider>
                            </PurchaseProvider>
                        </CustomerProvider>
                    </ProductProvider>
                </SupplierProvider>
            </CategoryProvider>
        // </UserProvider>
    );
}

function Sidebar({ isDropdownOpen, setIsDropdownOpen, handleLogout }) {
    const location = useLocation();
    const { user } = useUser(); // get user from UserContext

    const hasRole = (roleName) => {
        if (user.is_superuser) return true; // superuser has access to all routes
        // return user?.groups?.some(group => group.name === roleName);
        return user.groups.includes(roleName);
    };

    return (
        <div className="sidebar">
            <br />
            <h1>BEEQASI</h1>
            <ul>
                <li className={location.pathname === '/' ? 'active' : ''}><Link to="/">Home</Link></li>

                {(hasRole('Accountant' ) || hasRole('Administrator')) && (
                    <li className={location.pathname === '/accounting' ? 'active' : ''}><Link to="/accounting">Accounting</Link></li>
                )}
                {(hasRole('Accountant' ) || hasRole('Administrator')) && (
                    <li className={location.pathname === '/accounting/expense' ? 'active' : ''}><Link to="/accounting/expense">Expenses</Link></li>
                )}
                {(hasRole('Accountant') || hasRole('Administrator')) && (
                    <li className={location.pathname === '/accounting/currentassets' ? 'active' : ''}><Link to="/accounting/currentassets">Current Assets</Link></li>
                )}
                {(hasRole('Administrator') || hasRole('Manager')) && (
                    <li className={location.pathname === '/branches' ? 'active' : ''}><Link to="/branches">Branches</Link></li>
                )}
                {(hasRole('Inventory Manager') || hasRole('Administrator')) && (
                    <li className={`dropdown ${isDropdownOpen ? 'active' : ''}`}>
                        <div className="dropdown-header">
                            <Link to="/inventory" onClick={() => setIsDropdownOpen(false)}>Inventory</Link>
                            <button
                                type="button"
                                className="dropdown-arrow"
                                aria-label="Toggle Inventory menu"
                                aria-expanded={isDropdownOpen}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setIsDropdownOpen((prev) => !prev);
                                }}
                            >
                                &#10148;
                            </button>
                        </div>

                        {isDropdownOpen && (
                            <ul
                                className="dropdown-menu"
                            >
                                <li className={location.pathname === '/inventory/products' ? 'active' : ''}><Link to="/inventory/products" onClick={() => setIsDropdownOpen(false)}>Products</Link></li>
                                <li className={location.pathname === '/inventory/purchases' ? 'active' : ''}><Link to="/inventory/purchases" onClick={() => setIsDropdownOpen(false)}>Purchases</Link></li>
                                <li className={location.pathname === '/inventory/suppliers' ? 'active' : ''}><Link to="/inventory/suppliers" onClick={() => setIsDropdownOpen(false)}>Suppliers</Link></li>
                                <li className={location.pathname === '/inventory/store-inventory' ? 'active' : ''}><Link to="/inventory/store-inventory" onClick={() => setIsDropdownOpen(false)}>Store Inventory</Link></li>
                                <li className={location.pathname === '/inventory/reorder-levels' ? 'active' : ''}><Link to="/inventory/reorder-levels" onClick={() => setIsDropdownOpen(false)}>Reorder Levels</Link></li>
                                <li className={location.pathname === '/inventory/stock-transfer' ? 'active' : ''}><Link to="/inventory/stock-transfer" onClick={() => setIsDropdownOpen(false)}>Stock Transfer</Link></li>
                            </ul>
                        )}
                    </li>
                )}
                {(hasRole('Manager') || hasRole('Administrator')) && (
                    <li className={location.pathname === '/orders' ? 'active' : ''}><Link to="/orders">Orders</Link></li>
                )}
                {(hasRole('Manager') || hasRole('Administrator')) && (
                    <li className={location.pathname === '/CRM/customers' ? 'active' : ''}><Link to="/CRM/customers">Customers</Link></li>
                )}
                {(hasRole('Cashier') || hasRole('Administrator')) && (
                    <li className={location.pathname === '/pos' ? 'active' : ''}><Link to="/pos">POS</Link></li>
                )}
                {(hasRole('Manager') || hasRole('Administrator')) && (
                    <li className={location.pathname === '/reports' ? 'active' : ''}><Link to="/reports">Reports</Link></li>
                )}
                {hasRole('Administrator') && (
                    <li className={location.pathname === '/warehouse' ? 'active' : ''}><Link to="/warehouse">Warehouse</Link></li>
                )}
                {hasRole('Administrator') && (
                    <li className={location.pathname === '/audit-logs' ? 'active' : ''}><Link to="/audit-logs">Audit Log</Link></li>
                )}
                <li className={location.pathname === '/notes' ? 'active' : ''}><Link to="/notes">Notes</Link></li>
                {hasRole('Administrator') && (
                    <li className={location.pathname === '/company-info' ? 'active' : ''}><Link to="/company-info">Company Info</Link></li>
                )}
            </ul>
            <button className="logout-button btn btn-danger" onClick={handleLogout}>Logout</button>
        </div>
    );
}

function Home() {
    const { products, fetchAllProducts, totalProductsCount } = useProducts();
    const { orders, fetchOrders } = useOrders();
    const { fetchAccountsData } = useAccounts();
    const { loadTransactions } = useTransactions();
    const { customers, fetchCustomers } = useCustomers();
    const { suppliers, fetchAllSuppliers } = useSuppliers();
    const { purchases, fetchAllPurchases } = usePurchases();
    const { user } = useUser();
    const { notes, fetchAllNotes } = useNotes();

    const [totalSalesToday, setTotalSalesToday] = useState(0);
    const [totalPurchasesToday, setTotalPurchasesToday] = useState(0);
    const [totalCustomers, setTotalCustomers] = useState(0);
    const [totalSuppliers, setTotalSuppliers] = useState(0);
    const [todayNotes, setTodayNotes] = useState([]);

    useEffect(() => {
        fetchAllProducts();
        fetchOrders();
        fetchAccountsData();
        loadTransactions();
        fetchCustomers();
        fetchAllSuppliers();
        fetchAllPurchases();
        fetchAllNotes();
    }, [fetchAllProducts, fetchOrders, fetchAccountsData, loadTransactions, fetchCustomers, fetchAllSuppliers,
        fetchAllPurchases, fetchAllNotes]);

    useEffect(() => {
        // calculate total sales today
        if (orders && orders.length > 0) {
            const today = new Date().toISOString().split('T')[0];
            const todaysOrders = orders.filter((order) => {
                const orderDate = order.created_at || order.order_date;
                return orderDate && orderDate.startsWith(today);
            });

            const totalSales = todaysOrders.reduce(
                (acc, order) => acc + parseFloat(order.final_amount || 0),
                0
            );
            setTotalSalesToday(totalSales);
        }

        // set total customers
        if (customers && customers.length > 0) {
            setTotalCustomers(customers.length);
        }

        // set total suppliers
        if (suppliers && suppliers.length > 0) {
            setTotalSuppliers(suppliers.length);
        }

        // calculate total purchases today
        if (purchases && purchases.length > 0) {
            const today = new Date().toISOString().split('T')[0];
            const todaysPurchases = purchases.filter((purchase) => {
                const purchaseDate = purchase.created_at || purchase.purchase_date;
                return purchaseDate && purchaseDate.startsWith(today);
            });

            const totalPurchases = todaysPurchases.reduce(
                (acc, purchase) => acc + parseFloat(purchase.total_amount || 0),
                0
            );
            setTotalPurchasesToday(totalPurchases);
        }

        // set today's notes
        if (notes && notes.length > 0 && user) {
            const today = new Date().toISOString().split("T")[0];
            // console.log('Today:', today);

            const userSpecificNotes = notes.filter(
                (note) =>
                    note.user === user.user_id && // only notes for the logged-in user
                    note.reminder_date.split("T")[0] === today
            );
            setTodayNotes(userSpecificNotes);
            // console.log("Today's Notes for User:", userSpecificNotes);
        }

    }, [orders, customers, products, suppliers, purchases, notes, user]);

    return (
        <Container className="mt-5">
            {/*welcome banner*/}
            <Row className="mb-4">
                <Col>
                    <Card className="text-white bg-dark">
                        <Card.Body>
                            <Card.Title>
                                <h1 className="text-center">Welcome to Beeqasi Dashboard</h1>
                            </Card.Title>
                            <Card.Text className="text-center">
                                POS, Inventory, Accounting, CRM, and more....
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/*today's notes & reminders*/}
            {todayNotes.length > 0 && (
                <Row className="mb-4">
                    <Col>
                        <Card className="text-white bg-secondary">
                            <Card.Body>
                                <Card.Title>Today's Notes & Reminder</Card.Title>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Content</th>
                                            <th>Reminder Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {todayNotes.map((note) => (
                                            <tr key={note.id}>
                                                <td>{note.title}</td>
                                                <td>{note.content}</td>
                                                {/*<td>{note.reminder_date.split("T")[0]}</td>*/}
                                                <td>{new Date(note.reminder_date).toLocaleDateString("en-GB")}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}

            {/*quick access links*/}
            <Row className="mb-4">
                <Col md={3} className="mb-3">
                    <Link to="/pos" className="text-decoration-none">
                        <Card className="text-white bg-primary h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">POS</Card.Title>
                                <Card.Text className="text-center">
                                    Process sales
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col md={3} className="mb-3">
                    <Link to="/inventory" className="text-decoration-none">
                        <Card className="text-white bg-success h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">Inventory</Card.Title>
                                <Card.Text className="text-center">
                                    Manage products, stock, suppliers and purchases
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col md={3} className="mb-3">
                    <Link to="/accounting" className="text-decoration-none">
                        <Card className="text-white bg-warning h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">Accounting</Card.Title>
                                <Card.Text className="text-center">
                                    Manage accounts and transactions
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col md={3} className="mb-3">
                    <Link to="/reports" className="text-decoration-none">
                        <Card className="text-white bg-info h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">Reports</Card.Title>
                                <Card.Text className="text-center">
                                    View Reports
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                {/*accounts*/}
                <Col md={3} className="mb-3">
                    <Link to="/accounting/accounts" className="text-decoration-none">
                        <Card className="text-white bg-primary h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">Accounts</Card.Title>
                                <Card.Text className="text-center">
                                    View and manage accounts
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                {/*transactions*/}
                <Col md={3} className="mb-3">
                    <Link to="/accounting/transactions" className="text-decoration-none">
                        <Card className="text-white bg-success h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">Transactions</Card.Title>
                                <Card.Text className="text-center">
                                    View and record transactions
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                {/*purchases*/}
                <Col md={3} className="mb-3">
                    <Link to="/inventory/purchases" className="text-decoration-none">
                        <Card className="text-white bg-warning h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">Purchases</Card.Title>
                                <Card.Text className="text-center">
                                    View and manage purchases
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                {/*orders*/}
                <Col md={3} className="mb-3">
                    <Link to="/orders" className="text-decoration-none">
                        <Card className="text-white bg-info h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">Orders</Card.Title>
                                <Card.Text className="text-center">
                                    View and manage orders
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>

            {/*key statistics*/}
            <Row className="mb-4">
                <Col md={3} className="mb-3">
                    <Card className="text-white bg-secondary h-100">
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <Card.Title className="text-center">Total Sales Today</Card.Title>
                            <Card.Text className="text-center">
                               Ksh. {Math.ceil(totalSalesToday)}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3} className="mb-3">
                    <Card className="text-white bg-secondary h-100">
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <Card.Title className="text-center">Total Purchases Today</Card.Title>
                            <Card.Text className="text-center">
                                Ksh. {Math.ceil(totalPurchasesToday)}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3} className="mb-3">
                    <Card className="text-white bg-dark h-100">
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <Card.Title className="text-center">Total Customers</Card.Title>
                            <Card.Text className="text-center">
                                {totalCustomers}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3} className="mb-3">
                    <Link to="/inventory/products" className="text-decoration-none">
                        <Card className="text-white bg-primary h-100">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <Card.Title className="text-center">Total Products</Card.Title>
                                <Card.Text className="text-center">
                                    {totalProductsCount}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col md={3} className="mb-3">
                    <Card className="text-white bg-warning h-100">
                        <Card.Body className="d-flex flex-column justify-content-center">
                            <Card.Title className="text-center">Total Suppliers</Card.Title>
                            <Card.Text className="text-center">
                                {totalSuppliers}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/*quick links*/}
        </Container>
    );
}

export default App;
